import { Button, Input, Modal } from 'avo-ui'
import icX from 'assets/images/ic-x.svg'

export const AddAWBModal = ({ show, onHide, item, onChangeHandler, isLoading, onSubmit }) => {
    return (
        <Modal dialogClassName={'max-w-[400px]'} contentClassName={'rounded-xl'} show={show} onHide={onHide}>
            <>
                <div className={'flex px-3 pt-3 justify-end'}>
                    <img className={'w-5 cursor-pointer'} src={icX} alt='ic-x' onClick={onHide} />
                </div>
                <div className={'flex flex-col space-y-3 p-10'}>
                    <div className={'font-semibold text-blue-90 text-center'}>Masukkan Nomor Resi</div>
                    <Input
                        className={'flex-1'}
                        name={'awb'}
                        placeholder={'Masukkan nomor resi'}
                        value={item?.awb}
                        onChange={(item) => onChangeHandler(item?.value)}
                    />
                </div>
                <div className={'flex justify-center px-6 py-3 border-t'}>
                    <Button title={'Submit'} loading={isLoading} disabled={!item?.awb} onClick={onSubmit} />
                </div>
            </>
        </Modal>
    )
}
